import React from 'react';
import { motion } from 'framer-motion';
import { useProgressiveImage } from '../../hooks/useProgressiveImage';
import { IMAGES } from '../../data/images';

export default function HeroImage() {
  // Low quality placeholder for immediate display
  const placeholderSrc = "https://i.ibb.co/QvK05sQ/Bennystodrenge-Main-Hero.webp?tr=w-50,bl-30,q-50";
  const fullSrc = "https://i.ibb.co/QvK05sQ/Bennystodrenge-Main-Hero.webp";
  
  const currentSrc = useProgressiveImage(placeholderSrc, fullSrc);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="relative h-full flex items-center justify-center"
    >
      {/* Preload the full quality image */}
      <link rel="preload" as="image" href={IMAGES.hero.main} />
      
      <motion.img
        src={IMAGES.hero.main}
        alt="Vintage Pølsevogn"
        className="w-full h-auto max-h-[80vh] object-contain transition-opacity duration-300"
        loading="eager"
        fetchpriority="high"
        whileHover={{ 
          scale: 1.02,
          transition: { duration: 0.3 }
        }}
      />
      
      {/* Subtle decorative elements */}
      <div className="absolute -inset-4 bg-gradient-to-br from-red-500/5 to-amber-500/5 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full">
        <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-amber-500/5 rounded-full blur-3xl animate-pulse" />
      </div>
    </motion.div>
  );
}